import { useEffect, useRef } from 'react';
import type { LookAtThatLog } from '../../state/lookAtThatStore';

export function LookAtThatLog({ logs, onClear }: { logs: LookAtThatLog[]; onClear: () => void }) {
  const boxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Scroll only the log box itself (never the page — scrollIntoView here
    // used to drag the whole document down on every entry), and only when the
    // user is already pinned near the bottom so manual scrollback sticks.
    const el = boxRef.current;
    if (!el) return;
    const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    if (nearBottom) el.scrollTop = el.scrollHeight;
  }, [logs.length]);

  return (
    <div className="card">
      <div className="row" style={{ marginBottom: 8 }}>
        <h3 style={{ margin: 0 }}>Activity</h3>
        <span className="spacer" />
        <button type="button" className="btn small btn-ghost" onClick={onClear} disabled={logs.length === 0}>
          Clear
        </button>
      </div>
      <div className="look-at-that-log" ref={boxRef}>
        {logs.length === 0 ? (
          <p className="muted small" style={{ margin: 0 }}>
            No activity yet.
          </p>
        ) : (
          logs.map((log) => (
            <div key={log.id} className="look-at-that-log-line">
              <span className="muted small mono">
                {new Date(log.ts).toLocaleTimeString()}
              </span>
              <span className="small">{log.message}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
